// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-usageReportingContainer-components-tableHeader-module__header--h9mob {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  background-color: #071c35;
  color: #ffffff;
  font-size: 13px;
  border-radius: 4px 4px 0 0;
}

.src-js-pages-usageReportingContainer-components-tableHeader-module__titleRow--LQDqB {
  display: flex;
  align-items: center;
  gap: 12px;
}

.src-js-pages-usageReportingContainer-components-tableHeader-module__title--Bz748 {
  font-weight: 600;
  white-space: nowrap;
}

.src-js-pages-usageReportingContainer-components-tableHeader-module__controls--v82Xj {
  display: flex;
  align-items: center;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/js/pages/usageReportingContainer/components/tableHeader.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n  background-color: #071c35;\n  color: #ffffff;\n  font-size: 13px;\n  border-radius: 4px 4px 0 0;\n}\n\n.titleRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.title {\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `src-js-pages-usageReportingContainer-components-tableHeader-module__header--h9mob`,
	"titleRow": `src-js-pages-usageReportingContainer-components-tableHeader-module__titleRow--LQDqB`,
	"title": `src-js-pages-usageReportingContainer-components-tableHeader-module__title--Bz748`,
	"controls": `src-js-pages-usageReportingContainer-components-tableHeader-module__controls--v82Xj`
};
export default ___CSS_LOADER_EXPORT___;
